// GTM Tracking Utility Functions

// Initialize dataLayer if not exists
window.dataLayer = window.dataLayer || [];

// Generic function to push events to GTM
export const trackEvent = (eventName, parameters = {}) => {
  window.dataLayer.push({
    event: eventName,
    ...parameters
  });
  console.log('GTM Event:', eventName, parameters); // For debugging
};

// Social Media Click Tracking
export const trackSocialClick = (platform) => {
  trackEvent('social_media_click', {
    social_platform: platform,
    click_type: 'social_icon'
  });
};

// App Store Install Button Tracking
export const trackInstallClick = (store, url) => {
  trackEvent('app_install_click', {
    store_platform: store,
    app_name: 'Spurpunk',
    destination_url: url
  });
};

// Trailer Video Click Tracking
export const trackTrailerClick = (video_type = 'trailer') => {
  trackEvent('video_click', {
    video_type: video_type,
    video_title: 'Spurpunk Game Trailer',
    click_location: 'hero_section'
  });
};

// Newsletter Signup Tracking
export const trackNewsletterSignup = (email, name, success = true) => {
  trackEvent('newsletter_signup', {
    signup_method: 'website_form',
    user_email: email,
    user_name: name,
    signup_success: success
  });
};

// Modal/Share Button Tracking
export const trackModalOpen = (modal_type) => {
  trackEvent('modal_open', {
    modal_type: modal_type,
    interaction_type: 'button_click'
  });
}; 